import { ResolveModel } from "@calaosoft/osapp-common/utils/decorators/resolve-model.decorator";
import { BarecodeReaderSettings } from "./barecode-reader-settings";
import { DeliveriesSettings } from "./deliveries-settings";
import { ILogisticsSettings } from "./ilogistics-settings";

export class LogisticsSettings implements ILogisticsSettings {
	//#region PROPERTIES

	/** @implements */
	@ResolveModel(BarecodeReaderSettings)
	public barcodeReader: BarecodeReaderSettings;

	/** @implements */
	@ResolveModel(DeliveriesSettings)
	public deliveries: DeliveriesSettings;

	//#endregion

	//#region METHODS

	constructor(poData?: ILogisticsSettings) {
		this.barcodeReader = new BarecodeReaderSettings(poData?.barcodeReader);
		this.deliveries = new DeliveriesSettings(poData?.deliveries);
	}

	/** Retourne `true` si l'instance en paramètre est égale à l'instance courante, `false` sinon.
	 * @param poValue Instance à comparer.
	 */
	public equals(poValue?: ILogisticsSettings): boolean {
		return (
			this === poValue ||
			(this.barcodeReader.equals(poValue?.barcodeReader) && this.deliveries.equals(poValue?.deliveries))
		);
	}

	//#endregion METHODS
}
